import {createContext, useContext, useState, useEffect, Fragment } from 'react';
import { IReactNodeProps } from '../../interfaces/ComponentsInterfaces';

const SidebarContext: any = createContext(null);

export const useSidebar: any = () => useContext(SidebarContext);

// eslint-disable-next-line react/prop-types
export const NavSidebarExpandProvider = ({ children }: IReactNodeProps) => {
  
  
  // const getIsExpanded = (): boolean =>  {
  //   if(window.innerWidth > 768) return true
  //   return false
  // }

  const [isExpanded, setIsExpanded] = useState(false);
  // const [isWide, setIsWide]= useState(true);


  useEffect(() => {
    handleResize();
    addSelfAsListener()
    return () => {
      removeSelfAsListener();
    }
  }, []);

  //#region listener
  const addSelfAsListener = () => {
    window.addEventListener('resize', handleResize);
  }

  const removeSelfAsListener = () => {
    window.removeEventListener('resize', handleResize);
  }



  //handler
  const handleResize = () => {
    //setIsWide(window.innerWidth > 768);
    setIsExpanded(window.innerWidth > 768);
    //setIsExpanded(!(window.innerWidth < 768));
  };
  //#endregion


  const toggleSidebar = () => {
      setIsExpanded(!isExpanded);
  };

  return (
    // <SidebarContext.Provider value={{ isExpanded, isWide,  toggleSidebar }}>
    <SidebarContext.Provider value={{ isExpanded, toggleSidebar }}>
        {children}
    </SidebarContext.Provider>
  );
};

// interface IProps {
//     children?: ReactNode
//     // any props that come into the component
// }
